exports = module.exports = require("./../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "logo div{background-repeat:no-repeat;background-size:contain;background-position:0;width:100%;height:100%}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./client/app/components/common/logo/logo.scss
 ** module id = 168
 ** module chunks = 0
 **/